import { Injectable } from '@angular/core';
// @ts-ignore
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment.dev';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  private readonly secretKey = environment.symmetricKey;

  /**
   * Cifra un objeto o cadena en un payload base64 AES
   */
  encryptPayload(data: any): string {
    const text = typeof data === 'string' ? data : JSON.stringify(data);
    return CryptoJS.AES.encrypt(text, this.secretKey).toString();
  }

  /**
   * Descifra un payload cifrado por el servidor
   */
  decryptPayload(ciphertext: string): any {
    if (!ciphertext) return null;
    const bytes = CryptoJS.AES.decrypt(ciphertext, this.secretKey);
    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
    if (!decryptedStr) return null;
    try {
      return JSON.parse(decryptedStr);
    } catch (e) {
      return decryptedStr;
    }
  }
}
